class Megamenu {
  listenersAdded = false;

  constructor(e) {
    this.selectors = {
      announcementBar: ".m-announcement-bar",
      hamburgerButtons: ".m-menu-button",
      desktopMenuItems: [".m-menu__item"],
      desktopSubMenus: ".m-mega-menu",
      headerMobile: ".m-header__mobile",
      menuDrawer: "#m-menu-drawer",
      menuDrawerContent: ".m-menu-drawer__content",
      menu: ".m-menu-mobile",
      menuItems: [".m-menu-mobile__item"],
      megaMenuMobile: [".m-megamenu-mobile"],
      backDrop: ".m-menu-drawer__backdrop"
    };

    this.menuSelectors = {
      subMenu: ".m-mega-menu"
    };

    this.activeDesktopMenuItem = null;
    this.sliders = {};
    this.container = e;
    this.transitionDuration = 0;

    this.domNodes = queryDomNodes(this.selectors);

    this.menuData = [...this.domNodes.desktopMenuItems].map((e) => ({
      header: e.closest("header"),
      item: e,
      ...queryDomNodes(this.menuSelectors, e),
      active: false
    }));

    this.init();

    MinimogTheme = MinimogTheme || {};
    MinimogTheme.headerSliders = this.sliders;
  }

  /* ------------------------------------
     INIT
  ------------------------------------ */
  init() {
    this.domNodes.hamburgerButtons.addEventListener("click", (e) => {
      if (this.domNodes.hamburgerButtons.classList.contains("active")) {
        this.closeMenu();
      } else {
        this.openMenu();
      }
      this.domNodes.hamburgerButtons.classList.toggle("active");
    });

    this.domNodes.backDrop.addEventListener("click", () => this.closeMenu());

    this.initMobileMegaMenu();
    this.initDesktopMegaMenu();

    MinimogEvents.subscribe(MinimogTheme.pubSubEvents.openCartDrawer, () =>
      this.closeMenu()
    );

    MinimogEvents.subscribe(
      MinimogTheme.pubSubEvents.openSearchPopup,
      () => this.closeMenu()
    );
  }

  /* ------------------------------------
     DESKTOP MEGA MENU
  ------------------------------------ */
  initDesktopMegaMenu() {
    [...this.menuData].forEach((e) => {
      const { item: t, subMenu: s } = e;

      if (s) {
        const listEl = s.querySelector(".m-mega-product-list");

        if (listEl) {
          if (window && window.__sfWindowLoaded) {
            e.productsBannerSlider = this.initProductsBanner(listEl);
          } else {
            window.addEventListener("load", () => {
              e.productsBannerSlider = this.initProductsBanner(listEl);
            });
          }
        }
      }
    });
  }

  closeDesktopSubmenu = (index) => {
    const t = this.menuData[index];
    const { header: s } = t;
    s && s.classList.remove("show-menu");
  };

  initProductsBanner(el) {
    const t = el.closest("header");
    const screen = (t && `.${t.dataset.screen}`) || "";
    const id = el.dataset.id;
    const columns = document.querySelector(`.m-product-list-${id}`).dataset.column;

    const slider = new MinimogLibs.Swiper(`${screen} .m-product-list-${id}`, {
      slidesPerView: 1,
      loop: false,
      autoplay: false,
      breakpoints: {
        1200: { slidesPerView: columns },
        992: { slidesPerView: columns >= 2 ? 2 : columns }
      }
    });

    this.sliders[el.closest(".m-menu__item").dataset.index] = slider;

    if (slider) {
      const prev = document.querySelector(
        `#m-slider-controls-${id} .m-slider-controls__button-prev`
      );
      const next = document.querySelector(
        `#m-slider-controls-${id} .m-slider-controls__button-next`
      );

      prev && prev.addEventListener("click", () => slider.slidePrev());
      next && next.addEventListener("click", () => slider.slideNext());
    }
  }

  /* ------------------------------------
     MOBILE MEGA MENU
  ------------------------------------ */
  initMobileMegaMenu() {
    [...this.domNodes.menuItems].forEach((item) => {
      const submenu = item.querySelector(".m-megamenu-mobile");
      const backButton = item.querySelector(".m-menu-mobile__back-button");

      if (submenu) {
        addEventDelegate({
          context: item,
          selector: "[data-toggle-submenu]",
          handler: (e, target) => {
            e.preventDefault();
            const level = target.dataset.toggleSubmenu;
            const parent = e.target.parentNode;

            if (
              !e.target.classList.contains("m-menu-mobile__back-button") &&
              !parent.classList.contains("m-menu-mobile__back-button")
            ) {
              this.openSubMenu(submenu, level);
            }
          }
        });
      }

      if (backButton) {
        addEventDelegate({
          context: item,
          selector: "[data-toggle-submenu]",
          handler: (e, target) => {
            e.preventDefault();
            const level = target.dataset.toggleSubmenu;
            const parent = e.target.parentNode;

            if (
              !e.target.classList.contains("m-menu-mobile__back-button") &&
              !parent.classList.contains("m-menu-mobile__back-button")
            ) {
              this.openSubMenu(submenu, level);
            }
          }
        });

        backButton.addEventListener("click", (e) => {
          const level = e.target.dataset.level;
          this.closeSubMenu(submenu, level);
        });
      }
    });

    // 🚫 Removed old setMenuHeight() calls here — they caused Safari issues
  }

  /* ------------------------------------
     MENU OPEN / CLOSE
  ------------------------------------ */
  openMenu() {
    // Add listeners once only
    if (!this.listenersAdded) {
      this.setupMenuHeightListeners();
      this.listenersAdded = true;
    }

    document.documentElement.classList.add("prevent-scroll");
    this.domNodes.menuDrawer.classList.add("open");

    this.setMenuHeight(); // ensure correct height on open
  }

  closeMenu() {
    const { menuDrawer, menu, megaMenuMobile, hamburgerButtons } = this.domNodes;

    setTimeout(() => {
      megaMenuMobile.forEach((e) => e.classList.remove("open"));
      menu.classList.remove(
        "m-submenu-open",
        "m-submenu-open--level-1",
        "m-submenu-open--level-2"
      );
      menuDrawer.classList.remove("open");
      document.documentElement.classList.remove("prevent-scroll");
      hamburgerButtons.classList.remove("active");
    }, this.transitionDuration);
  }

  /* ------------------------------------
     SUBMENUS
  ------------------------------------ */
  openSubMenu(el, level) {
    const cls = `m-submenu-open--level-${level}`;
    this.domNodes.menuDrawerContent.classList.add("open-submenu");
    this.domNodes.menu.classList.add("m-submenu-open");
    this.domNodes.menu.classList.add(cls);
    el.classList.add("open");
  }

  closeSubMenu(el, level) {
    const cls = `m-submenu-open--level-${level}`;

    if (level === "1") {
      this.domNodes.menu.classList.remove("m-submenu-open");
    }

    this.domNodes.menu.classList.remove(cls);
    el.classList.remove("open");
    this.domNodes.menuDrawerContent.classList.remove("open-submenu");
  }

  /* ------------------------------------
     SAFARI-SAFE MENU HEIGHT
  ------------------------------------ */
setMenuHeight() {
  const { menuDrawer, headerMobile } = this.domNodes;
  const announcementBar = document.querySelector('.m-announcement-bar');

  if (!menuDrawer || !headerMobile) return;

  // Safari-safe viewport height
  let viewportHeight = window.visualViewport
    ? window.visualViewport.height - window.visualViewport.offsetTop
    : window.innerHeight;

  // Header height
  const headerBottom = headerMobile.offsetHeight;

  // Announcement bar visible height (0 if scrolled off)
  let visibleAnnouncementHeight = 0;
  if (announcementBar) {
    const rect = announcementBar.getBoundingClientRect();
    visibleAnnouncementHeight = Math.max(0, rect.bottom); // visible portion
  }

  // Calculate drawer height
  const drawerHeight = viewportHeight - headerBottom - visibleAnnouncementHeight;

  // Position drawer below header + visible announcement bar
  menuDrawer.style.top = headerBottom + visibleAnnouncementHeight + 'px';

  // Set CSS variable
  menuDrawer.style.setProperty("--menu-drawer-height", `${drawerHeight}px`);
}


  setupMenuHeightListeners() {
    window.addEventListener("resize", () => this.setMenuHeight());

    if (window.visualViewport) {
      window.visualViewport.addEventListener("resize", () =>
        this.setMenuHeight()
      );
    }
  }
}

class SiteNav {
    constructor(e) {
        this.selectors = {
            menuItems: [".m-menu .m-menu__item"],
            dropdowns: [".m-mega-menu"],
            subMenu: ".m-mega-menu",
            overlay: ".m-header__overlay",
            swiper: ".swiper-container"
        }, this.classes = {
            slideFromRight: "slide-from-right",
            slideReveal: "slide-reveal",
            active: "m-mega-active"
        }, this.headerSticky = !1, e && (this.container = e, this.domNodes = queryDomNodes(this.selectors, this.container), this.activeIndex = -1, this.lastActiveIndex = -1, this.visited = !1, this.timeoutEnter = null, this.timeoutLeave = null, this.attachEvents())
    }
    attachEvents = () => {
        this.domNodes.menuItems.forEach(((e, t) => {
            e.addEventListener("mouseenter", (e => this.onMenuItemEnter(e, t))), e.addEventListener("mouseleave", (e => this.onMenuItemLeave(e, t)))
        }))
    };
    initDropdownSize = () => {
        this.container && this.container.style.setProperty("--sf-dropdown-width", this.windowWidth()), this.container && this.container.style.setProperty("--sf-dropdown-height", this.windowHeight())
    };
    onMenuItemEnter = (e, t) => {
        const {
            target: s
        } = e;
        s.classList.contains("m-menu__item--mega") && (clearTimeout(this.timeoutLeave), this.activeIndex = s.dataset && Number(s.dataset.index), this.headerSticky = this.container && "true" === this.container.dataset.sticky, this.reInitSlider(s), this.container && this.visited ? this.container.classList.remove(this.classes.slideReveal) : this.container.classList.add(this.classes.slideReveal), this.visited = !0, this.lastActiveIndex >= 0 && this.activeIndex >= 0 && (this.container && this.lastActiveIndex < this.activeIndex ? this.container.classList.add(this.classes.slideFromRight) : this.lastActiveIndex > this.activeIndex && this.container.classList.remove(this.classes.slideFromRight)), this.getElementBoundingRect(s).then((e => {
            e && (this.container && this.container.style.setProperty("--sf-dropdown-width", e.width), this.container && this.container.style.setProperty("--sf-dropdown-height", e.height)), this.timeoutEnter = setTimeout((() => {
                this.activeIndex === Number(s.dataset.index) && (this.container && this.container.classList.add(this.classes.active), s.closest(".m-menu__item").classList.add("m-menu__item--active"))
            }), 120)
        })))
    };
    onMenuItemLeave = (e, t) => {
        this.activeIndex = -1, this.lastActiveIndex = t, e.target.closest(".m-menu__item").classList.remove("m-menu__item--active"), this.timeoutLeave = setTimeout((() => {
            (-1 === this.activeIndex || this.activeIndex < 0) && (this.visited = !1), this.resetMegaMenu(e.target)
        }), 80)
    };
    reInitSlider = e => {
        if (!e.querySelector(this.selectors.swiper)) return;
        const t = e.dataset.index,
            s = MinimogTheme && MinimogTheme.headerSliders[t];
        s && s.update()
    };
    getElementBoundingRect = async e => {
        const t = e.querySelector(this.selectors.subMenu);
        if (t) {
            const e = t.getBoundingClientRect();
            return {
                width: e.width,
                height: e.height,
                left: e.left,
                top: e.top
            }
        }
    };
    resetMegaMenu = () => {
        this.activeIndex = -1, clearTimeout(this.timeoutEnter), this.container && this.container.classList.remove(this.classes.active, this.classes.slideFromRight, this.classes.slideReveal, "sf-header--bg-black", "sf-header--bg-white")
    };
    windowWidth = () => window.innerWidth;
    windowHeight = () => window.innerHeight;
    destroy = () => {
        this.domNodes.menuItems.forEach(((e, t) => {
            e.removeEventListener("mouseenter", (e => this.onMenuItemEnter(e, t))), e.removeEventListener("mouseleave", (e => this.onMenuItemLeave(e, t)))
        }))
    }
}